import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import paywallsActions from 'redux/actions/paywallsActions'
import View from 'views/paywalls/google_slides_unauthorized_create_view'

class GoogleSlidesAddOnNotSupportedContainer extends PureComponent {
	trialCode = 'NP-GOLDGS'

	handleUpgradeSelected = () => {
		this.props.actions.upgradeSelected(this.trialCode)
	}

	render() {
		return (
			<View
				handleUpgrade={this.handleUpgradeSelected}
				upgradeCode={this.trialCode}
				shouldRenderSmallerView
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		upgradeSelected: paywallsActions.googleSlidesAddonUpgrade,
	}, dispatch)
}

GoogleSlidesAddOnNotSupportedContainer.propTypes = {
	actions: PropTypes.shape({
		upgradeSelected: PropTypes.func.isRequired,
	}).isRequired,
}

export default connect(null, mapDispatchToProps)(GoogleSlidesAddOnNotSupportedContainer)

export {GoogleSlidesAddOnNotSupportedContainer}
